import moment from 'moment-timezone';

export const test = {
  currentPage: 1,
  itemsPerPage: 10,
  items: [],
  filter: {
    campaignId: '',
    appId: '',
    adType: '',
    placementName: '',
    placementId: '',
    id: '',
    country: '',
    platform: '',
    status: 'served',
    userId: '',
    publisherId: '',
    externalUserId: '',
    impressionDate: {
      from: moment().tz('America/Los_Angeles')
        .startOf('day')
        .format('MM/DD/YYYY'),
      to: '',
    },
  },
  sort: {
    key: 'timestamp',
    order: -1,
  },
  showCSVModal: false,
  isFetching: false,
  fetchingErrorMessage: '',
};

export const initial = {
  currentPage: 1,
  itemsPerPage: 10,
  items: [],
  filter: {
    campaignId: '',
    appId: '',
    adType: '',
    placementName: '',
    placementId: '',
    id: '',
    country: '',
    platform: '',
    status: 'served',
    userId: '',
    publisherId: '',
    externalUserId: '',
    impressionDate: {
      from: moment().tz('America/Los_Angeles')
        .startOf('day')
        .format('MM/DD/YYYY'),
      to: '',
    },
  },
  sort: {
    key: 'timestamp',
    order: -1,
  },
  showCSVModal: false,
  isFetching: false,
  fetchingErrorMessage: '',
};



/** WEBPACK FOOTER **
 ** ./js/redux/state/impressions.state.js
 **/